import React from 'react';
import {
  View,
  Text,
  Image,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const PlanetDetailScreen = ({ route, navigation }) => {
  const { planet } = route.params;

  return (
    <ScrollView style={styles.container}>
      <Image
        source={{ uri: planet.image || 'https://via.placeholder.com/300' }}
        style={styles.image}
        resizeMode="contain"
      />
      <View style={styles.infoContainer}>
        <Text style={styles.name}>{planet.name}</Text>
        
        <View style={styles.infoRow}>
          <MaterialCommunityIcons name="map-marker" size={24} color="#f4511e" />
          <Text style={styles.infoText}>Location: {planet.location || 'Unknown'}</Text>
        </View>

        <View style={styles.infoRow}>
          <MaterialCommunityIcons name="weather-sunny" size={24} color="#f4511e" />
          <Text style={styles.infoText}>Climate: {planet.climate || 'Unknown'}</Text>
        </View>

        <View style={styles.infoRow}>
          <MaterialCommunityIcons name="account-group" size={24} color="#f4511e" />
          <Text style={styles.infoText}>Population: {planet.population || 'Unknown'}</Text>
        </View>

        <View style={styles.descriptionContainer}>
          <Text style={styles.descriptionTitle}>Description</Text>
          <Text style={styles.description}>{planet.description || 'No description available'}</Text>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  image: {
    width: 300,
    height: 300,
    alignSelf: 'center',
    resizeMode: 'contain',
    backgroundColor: '#f0f0f0',
  },
  infoContainer: {
    padding: 20,
  },
  name: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 20,
    textAlign: 'center',
  },
  infoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    backgroundColor: 'white',
    padding: 10,
    borderRadius: 8,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },
  infoText: {
    fontSize: 16,
    color: '#333',
    marginLeft: 10,
  },
  descriptionContainer: {
    marginTop: 20,
    backgroundColor: 'white',
    padding: 15,
    borderRadius: 8,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
  },
  descriptionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 10,
  },
  description: {
    fontSize: 16,
    color: '#666',
    lineHeight: 24,
  },
});

export default PlanetDetailScreen; 